var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C8.24517 6 4.99352 8.09599 3.39011 11.156C3.11315 11.6845 3.11315 12.3155 3.39011 12.844C4.99352 15.904 8.24518 18 12 18C15.7548 18 19.0065 15.904 20.6099 12.844C20.8869 12.3155 20.8869 11.6845 20.6099 11.156C19.0065 8.09599 15.7548 6 12 6ZM12 16C9.74182 16 7.90909 14.208 7.90909 12C7.90909 9.792 9.74182 8 12 8C14.2582 8 16.0909 9.792 16.0909 12C16.0909 14.208 14.2582 16 12 16ZM12 9.6C10.6418 9.6 9.54545 10.672 9.54545 12C9.54545 13.328 10.6418 14.4 12 14.4C13.3582 14.4 14.4545 13.328 14.4545 12C14.4545 10.672 13.3582 9.6 12 9.6Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b68716ad0d8e2de3e70f9f55a94a4377.svg";
export { ForwardRef as ReactComponent };